export class Departement {
    id: number;
    name: string;
    code: string;
}


